/** @format */

/** Feedback on the SOP title page (TipTap on `/sop/:id`) uses this step index. */
export const TITLE_PAGE_FEEDBACK_STEP_INDEX = -1;
